export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
export const SET_LOCALES = 'SET_LOCALES';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_BOOKING_HISTORY = 'SET_BOOKING_HISTORY';
export const SET_LANGUAGES = 'SET_LANGUAGES';
export const SET_CURRENT_LANGUAGE_ID = 'SET_CURRENT_LANGUAGE_ID';
export const SET_CHARGING = 'SET_CHARGING';
export const SET_LEVELS = 'SET_LEVELS';
export const SET_CURRENT_LEVEL_ID = 'SET_CURRENT_LEVEL_ID';
export const SET_AMOUNTS = 'SET_AMOUNTS';
export const SET_TEACHER_ONLINE = 'SET_TEACHER_ONLINE';
export const SET_TERMS = 'SET_TERMS';
export const SET_USER_BALANCE = 'SET_USER_BALANCE';
export const SET_CURRENT_USER_BALANCE = 'SET_CURRENT_USER_BALANCE';
export const DECREMENT_COIN = 'DECREMENT_COIN';

export const INITIAL_DATA_RECEIVED = 'INITIAL_DATA_RECEIVED';
export const SECONDARY_DATA_RECEIVED = 'SECONDARY_DATA_RECEIVED';

export const SET_LESSON = 'SET_LESSON';
export const SET_VIDEO_START = 'SET_VIDEO_START';
export const FINISH_LESSON = 'FINISH_LESSON';
export const SET_HISTORY_LESSON = 'SET_HISTORY_LESSON';
export const SET_MESSAGES_TO_HISTORY = 'SET_MESSAGES_TO_HISTORY';

export const SET_REQUEST = 'SET_REQUEST';
export const REMOVE_REQUEST = 'REMOVE_REQUEST';

export const SET_MESSAGES = 'SET_MESSAGES';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_ATTACHMENTS_MESSAGE_LOADING = 'SET_ATTACHMENTS_MESSAGE_LOADIN';
export const INCREMENT_SENT_MESSAGE_WITH_ATTACHMENTS =
  'INCREMENT_SENT_MESSAGE_WITH_ATTACHMENTS';
export const DELETE_ALL_MESSAGES = 'DELETE_ALL_MESSAGES';
export const SET_MESSAGE_MARK = 'SET_MESSAGE_MARK';
